// Angular dependencies.
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Effect, Actions } from '@ngrx/effects';
import { Action } from '@ngrx/store';

// Rxjs dependencies
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/ignoreElements';
import { Observable } from 'rxjs/Observable';

// Store
import { Store } from '@ngrx/store';
import { AppState, selectCreeps } from './app.reducer';
import { UPDATE_LINK, GOTO_MAIN, GOTO_BACK } from './app.actions';

// App dependencies.
import { Creep } from '../creep';

@Injectable()
export class AppEffects {
  @Effect({ dispatch: false })
  gotoBackLink$: Observable<Action> = this.actions$
    .ofType(GOTO_BACK)
    .do(() => {
      this._location.back();
    });

  @Effect({ dispatch: false })
  gotoMainLink$: Observable<Creep[]> = this.actions$
    .ofType(GOTO_MAIN)
    .switchMap(() => this._store.select(selectCreeps))
    .do((creeps) => {
      const creepsStr = creeps
        .map((creep: Creep) => '' + creep)
        .join(',');

      this._router.navigate([''], {
        queryParams: {
          'creeps': creepsStr
        }
      });
    });

  @Effect({ dispatch: false })
  updateLink$: Observable<Creep[]> = this.actions$
    .ofType(UPDATE_LINK)
    .switchMap(() => this._store.select(selectCreeps))
    .do((creeps) => {
      const creepsStr = creeps
        .map((creep: Creep) => '' + creep)
        .join(',');

      this._router.navigate(['.'], {
        queryParams: {
          'creeps': creepsStr
        },
        relativeTo: this._route
      });
    });

    constructor(
      private actions$: Actions,
      private _store: Store<AppState>,
      private _route: ActivatedRoute,
      private _router: Router,
      private _location: Location
    ) { }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/store.module/app.effects.ts